import React from 'react'
import PropTypes from 'prop-types'

import { Field } from 'react-final-form'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '../../ui/Fields/TextField'
import Select from '../../ui/Fields/Select'
import styles from '@styles/forms'

const Form = props => {
  const {
    action,
    classes,
    handleSubmit,
    sensor_configs,
    selectValues: { manualTypes },
    o
  } = props

  return (
    <form className={classes.form} onSubmit={handleSubmit} data-testid="manual-equipment-form">
      <main className={classes.form__fields}>
        <Grid container spacing={24}>
          <Grid item xs={8}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.name')}
                margin="normal"
                name="equipment[name]"
                required
                type="text"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={4}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={Select}
                data={sensor_configs}
                InputLabelProps={{ shrink: true }}
                fields={{ id: 'id', name: 'name' }}
                fullWidth
                label={I18n.t('v4/equipment.attributes.type')}
                margin="normal"
                name="equipment[sensor_config_id]"
                required
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.equipment_model')}
                margin="normal"
                name="equipment[equipment_model]"
                type="text"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.brand')}
                margin="normal"
                name="equipment[brand]"
                type="text"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.latitude')}
                margin="normal"
                name="equipment[latitude]"
                inputProps={{ step: '0.000001' }}
                required
                type="number"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.longitude')}
                margin="normal"
                name="equipment[longitude]"
                inputProps={{ step: '0.000001' }}
                required
                type="number"
                variant="outlined"
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className={classes.form__field__wrapper}>
              <Field
                className={classes.form__fieldWithError}
                component={TextField}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={I18n.t('v4/equipment.attributes.detail')}
                margin="normal"
                name="equipment[detail]"
                multiline
                variant="outlined"
              />
            </div>
          </Grid>
        </Grid>
      </main>

      <footer className={classes.form__actions}>
        <Button
          className={classes.form__action}
          color='primary'
          type='submit'
          variant='contained'
        >
          {`${action} ${I18n.t('v4/equipment.kinds.manual')}`}
        </Button>

        <Button
          className={classes.form__action}
          color='secondary'
          href={`/v4/o/${o}/equipments/manual`}
        >
          {I18n.t('actions.back')}
        </Button>
      </footer>
    </form>
  )
}

Form.propTypes = {
  action: PropTypes.string,
  selectValues: PropTypes.objectOf(PropTypes.array)
}

export default withStyles(styles)(Form)
